class ArticleFilter extends HTMLElement {
  constructor() {
    super();

    this.searchTrigger = this.querySelector('.js-search');
    this.searchField = this.querySelector('.js-filters-search');


    this.searchQuery = window.location.search;

    if (this.searchQuery && this.searchQuery.includes('?query=')) {
      const searchTerm = this.searchQuery;
      this.apiCall(searchTerm.split('?query=')[1]);
      this.searchField.value = searchTerm.split('?query=')[1];
    }

    if (this.searchTrigger) {
      this.searchTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.searchField.dataset.type == 'blog') {
          this.apiCall(this.searchField.value, false);
          this.searchField.value = value;
        } else {
          this.formAction = this.querySelector('form').action;
          window.location.href = this.formAction + '?query=' + this.searchField.value;
        }
      });
    }
  }

  apiCall(searchTerm) {
    fetch(
      `${window.routes.search_url}?q=${encodeURIComponent(
        searchTerm
      )}&type=article`,
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('.product-grid').innerHTML;
        this.updateResults(resultsMarkup);
        this.closeSidebar();
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        throw error;
      });
  }

  updateResults(results) {
    const blogArticles = document.querySelector('.blog-articles');
    if (results == "") {
      console.info("No Results Found");
      results = `<div class="blog-articles__no-results grid--item grid--colspan-3"><strong>` + window.blog.no_found + `</strong></div>`
    }
    if (blogArticles) {
      blogArticles.innerHTML = results;
    }
  }

  closeSidebar() {
    this.closest('side-drawer').close()
  }
}

customElements.define("article-filter", ArticleFilter);